<template>
  <div class="widget-reserves">
    <div class="card owl-item bg-darkred">
       <div class="card-header">
          <h5>Ara mateix {{ data.datareserves }}</h5>
       </div>

       <span class="badge badge-primary border-radius-0 subtitol" style="padding:15px 20px; text-align:left; background-color:#0073CF; border-radius:0; font-size:15px"><strong>Reserves {{ data.terminal }}</strong> </span>
        
       <div class="card-body">
         <Reserversicon />
       </div>

       <div class="card-body capacitat-box first">
          
             <h5 style="display: inline-block;">Capacitat total dia</h5> &emsp;
             <h1 style="display: inline-block; font-size:25px">
             <span class="badge" style="font-size:25px">{{ data.capacitattotaldia }}</span>
             </h1>
        
       </div>

       <div class="card-body capacitat-box">
           
             <h5 style="display: inline-block;">Reserves disponibles</h5> &emsp;
             <h1 style="display: inline-block; font-size:25px">
             <span class="badge" style="font-size:25px">{{ data.reservesdisponibles }}</span>
             </h1>
           
       </div>


       <div class="card-body percentatge-box">
          <span class="badge" style="font-size:15px; padding-left:0; color:#4D5357">Estat a: <strong>{{ data.datareserves }} </strong> </span>

          <table class="table border-0">
            <tbody><tr style="border-bottom: 0rem; border-top: 0rem;">
              <td style="padding-left:0; font-size:16px">
                Moviments realitzats (%)
                <div class="progress" style="height: 1.875rem; font-size: 0.9rem; margin: 0.3125rem 0rem 0.625rem 0rem;background-color:#fff">
                    <div class="progress-bar" role="progressbar" :aria-valuenow=data.movcodecosfetsdiaxcent :style="this.getWith(data.movcodecosfetsdiaxcent)" aria-valuemin="0" aria-valuemax="100">{{ data.movcodecosfetsdiaxcent }}%</div>

                    <!-- % 5% -->
                </div>
                Reserves fetes (%)
                <div class="progress" style="height: 1.875rem; font-size: 15px; margin: 0.3125rem 0rem 0.625rem  0rem; background-color:#fff">
                    <div class="progress-bar second" role="progressbar" style="background-color:#002664" :aria-valuenow=data.reservesfetesdiaxcent :style="this.getWith(data.reservesfetesdiaxcent)" aria-valuemin="0" aria-valuemax="100">{{ data.reservesfetesdiaxcent }}%</div>
                    <!-- % 23% -->
                </div>
              </td>
              
              <td style="text-align:right; font-size:16px">
                  Nombre
                  <div style="height: 1.875rem; font-size: 0.rem; margin: 0.3125rem 0rem 0.625rem  0rem;">
                      <span style="font-weight:bold; color:#4D5357">{{ data.movcodecosfetsdia }}</span>
                  </div>

                  Nombre
                  <div style="height: 1.875rem; font-size: 15px; margin: 0.3125rem 0rem 0.625rem  0rem;">
                      <span style="font-weight:bold; color:#4D5357">{{ data.reservesfetesdia }} </span>
                  </div>
              </td>
            </tr>
          </tbody></table>

    
   </div>          
  </div>
  </div>
</template>
<script>
import Reserversicon from './Icons/Reservesicon.vue';
export default {
  name: 'Summary',
  props: {
    data: Object
  },
  components: { Reserversicon },
  methods: {
    getWith(width){
      return {
        width: width+'%'
      }
    }
  }
}
</script>